import { Upload, Button } from 'antd';
import { UploadChangeParam, UploadFile } from 'antd/lib/upload/interface';
import React, { useState } from 'react';

interface UploadFormGroupProps {
    label: string;
    value?: string;
    onChange(value?: string): void;
}

const UploadFormGroup: React.FC<UploadFormGroupProps> = ({ label, value, onChange }) => {
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const uploadDisabled = !!value;

    const onFileChange = (filesObject: UploadChangeParam) => {
        const newFileList = filesObject.fileList.length > 0 ? [filesObject.fileList[0]] : [];

        setFileList(newFileList);
    };

    const onImageRemove = () => {
        onChange();
        setFileList([]);
    };

    return (
        <>
            <div style={{ gridColumn: 1 }}>
                <strong>{label}:</strong>
            </div>
            <div style={{ gridColumn: '2/5' }}>
                <Upload
                    fileList={fileList}
                    customRequest={({ file, onSuccess }) => {
                        onChange(URL.createObjectURL(file as any));
                        setTimeout(() => {
                            if (!onSuccess) return;
                            // it has to be async, otherwise the callback is not handled;
                            onSuccess('ok' as any, file as any);
                        }, 16);
                    }}
                    multiple={false}
                    disabled={uploadDisabled}
                    onChange={onFileChange}
                >
                    {uploadDisabled ? (
                        <Button icon={'remove'} onClick={onImageRemove}>
                            Remove image
                        </Button>
                    ) : (
                        <Button disabled={uploadDisabled} icon={'upload'}>
                            Click to set image
                        </Button>
                    )}
                </Upload>
            </div>
        </>
    );
};

export default UploadFormGroup;
